$(function () {

	$(document).on('click', '.ajax-case-pagination .js-load-more', function () {
		var page = parseInt($('.other-case-list').attr('data-page')),
			offset = parseInt($('.other-case-list').attr('data-offset')),
			all = parseInt($('.other-case-list').attr('data-all-post'));

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				'action': 'load_more_case',
				'page': ++page,
			},

			success: function (response) {
				var html = response.substr(0, response.length - 1);

				console.log($(html).find('.other-case-list'))

				$('.other-case-list').append($(html).find('.other-case-list').html());
				$('.ajax-case-pagination').html($(html).find('.ajax-case-pagination').html());

				$('.other-case-list').attr('data-page', page);
				history.replaceState({}, '', '?pagination=' + page);
			}
		});

		return false;
	});


	$(document).on('click', '.ajax-case-pagination .page-numbers', function () {
		var page = parseInt($(this).attr('data-page'));

		$.ajax({
			url: '/wp-admin/admin-ajax.php',
			type: 'POST',
			data: {
				'action': 'load_more_case',
				'page': page,
				'append': false,
			},

			success: function (response) {
				$('.js-other-case-list').html(response.substr(0, response.length - 1));
				history.replaceState({}, '', '?pagination=' + page);
			}
		});

		return false;
	});

});